import React from 'react';
import { AuthPage } from './AuthLayout';
import SetupPassword from './SetupPassword';

export default function SetupPasswordPage() {
    return <AuthPage>
        <SetupPassword />
    </AuthPage>;
}
